var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 384,
    viewBox: "0 0 501 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 368.646L1 383.355L15.7092 383.355L15.7092 368.646L0.999999 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 353.936L1 368.646L15.7092 368.646L15.7092 353.936L0.999999 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 339.234L1 353.943L15.7092 353.943L15.7092 339.234L0.999999 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 324.525L1 339.234L15.7092 339.234L15.7092 324.525L0.999999 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 309.823L1 324.532L15.7092 324.532L15.7092 309.823L0.999999 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 295.114L1 309.823L15.7092 309.823L15.7092 295.114L0.999999 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 280.411L1 295.121L15.7092 295.121L15.7092 280.411L0.999999 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 265.702L1 280.411L15.7092 280.411L15.7092 265.702L0.999999 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 251L1 265.709L15.7092 265.709L15.7092 251L0.999999 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 236.291L1 251L15.7092 251L15.7092 236.291L0.999999 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 221.589L1 236.298L15.7092 236.298L15.7092 221.589L0.999999 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 206.88L1 221.589L15.7092 221.589L15.7092 206.88L0.999999 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 192.178L1 206.887L15.7092 206.887L15.7092 192.178L0.999999 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 177.468L1 192.177L15.7092 192.177L15.7092 177.468L0.999999 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 162.766L1 177.475L15.7092 177.475L15.7092 162.766L0.999999 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 148.057L1 162.766L15.7092 162.766L15.7092 148.057L0.999999 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 133.355L1 148.064L15.7092 148.064L15.7092 133.355L0.999999 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 118.645L1 133.354L15.7092 133.354L15.7092 118.645L0.999999 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 103.936L1 118.646L15.7092 118.646L15.7092 103.936L0.999999 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 89.2341L1 103.943L15.7092 103.943L15.7092 89.2341L0.999999 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 74.5251L1 89.2344L15.7092 89.2344L15.7092 74.5251L0.999999 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 59.823L1 74.5322L15.7092 74.5322L15.7092 59.823L0.999999 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 45.1135L1 59.8228L15.7092 59.8228L15.7092 45.1135L0.999999 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 30.4114L1 45.1206L15.7092 45.1206L15.7092 30.4114L0.999999 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 15.7024L1 30.4116L15.7092 30.4116L15.7092 15.7024L0.999999 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 1.00026L1 15.7095L15.7092 15.7095L15.7092 1.00026L0.999999 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 368.646L15.7092 383.355L30.4184 383.355L30.4184 368.646L15.7092 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 353.936L15.7092 368.646L30.4184 368.646L30.4184 353.936L15.7092 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 339.234L15.7092 353.943L30.4184 353.943L30.4184 339.234L15.7092 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 324.525L15.7092 339.234L30.4184 339.234L30.4184 324.525L15.7092 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 309.823L15.7092 324.532L30.4184 324.532L30.4184 309.823L15.7092 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 295.114L15.7092 309.823L30.4184 309.823L30.4184 295.114L15.7092 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 280.411L15.7092 295.121L30.4184 295.121L30.4184 280.411L15.7092 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 265.702L15.7092 280.411L30.4184 280.411L30.4184 265.702L15.7092 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 251L15.7092 265.709L30.4184 265.709L30.4184 251L15.7092 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 236.291L15.7092 251L30.4184 251L30.4184 236.291L15.7092 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 221.589L15.7092 236.298L30.4184 236.298L30.4184 221.589L15.7092 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 206.88L15.7092 221.589L30.4184 221.589L30.4184 206.88L15.7092 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 192.178L15.7092 206.887L30.4184 206.887L30.4184 192.178L15.7092 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 177.468L15.7092 192.177L30.4184 192.177L30.4184 177.468L15.7092 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 162.766L15.7092 177.475L30.4184 177.475L30.4184 162.766L15.7092 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 148.057L15.7092 162.766L30.4184 162.766L30.4184 148.057L15.7092 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 133.355L15.7092 148.064L30.4184 148.064L30.4184 133.355L15.7092 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 118.645L15.7092 133.354L30.4184 133.354L30.4184 118.645L15.7092 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 103.936L15.7092 118.646L30.4184 118.646L30.4184 103.936L15.7092 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 89.2341L15.7092 103.943L30.4184 103.943L30.4184 89.2341L15.7092 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 74.5251L15.7092 89.2344L30.4184 89.2344L30.4184 74.5251L15.7092 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 59.823L15.7092 74.5322L30.4184 74.5322L30.4184 59.823L15.7092 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 45.1135L15.7092 59.8228L30.4184 59.8228L30.4184 45.1135L15.7092 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 30.4114L15.7092 45.1206L30.4184 45.1206L30.4184 30.4114L15.7092 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 15.7024L15.7092 30.4116L30.4184 30.4116L30.4184 15.7024L15.7092 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7092 1.00026L15.7092 15.7095L30.4184 15.7095L30.4184 1.00026L15.7092 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 368.646L30.4121 383.355L45.1213 383.355L45.1213 368.646L30.4121 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 353.936L30.4121 368.646L45.1213 368.646L45.1213 353.936L30.4121 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 339.234L30.4121 353.943L45.1213 353.943L45.1213 339.234L30.4121 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 324.525L30.4121 339.234L45.1213 339.234L45.1213 324.525L30.4121 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 309.823L30.4121 324.532L45.1213 324.532L45.1213 309.823L30.4121 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 295.114L30.4121 309.823L45.1213 309.823L45.1213 295.114L30.4121 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 280.411L30.4121 295.121L45.1213 295.121L45.1213 280.411L30.4121 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 265.702L30.4121 280.411L45.1213 280.411L45.1213 265.702L30.4121 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 251L30.4121 265.709L45.1213 265.709L45.1213 251L30.4121 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 236.291L30.4121 251L45.1213 251L45.1213 236.291L30.4121 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 221.589L30.4121 236.298L45.1213 236.298L45.1213 221.589L30.4121 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 206.88L30.4121 221.589L45.1213 221.589L45.1213 206.88L30.4121 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 192.178L30.4121 206.887L45.1213 206.887L45.1213 192.178L30.4121 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 177.468L30.4121 192.177L45.1213 192.177L45.1213 177.468L30.4121 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 162.766L30.4121 177.475L45.1213 177.475L45.1213 162.766L30.4121 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 148.057L30.4121 162.766L45.1213 162.766L45.1213 148.057L30.4121 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 133.355L30.4121 148.064L45.1213 148.064L45.1213 133.355L30.4121 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 118.645L30.4121 133.354L45.1213 133.354L45.1213 118.645L30.4121 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 103.936L30.4121 118.646L45.1213 118.646L45.1213 103.936L30.4121 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 89.2341L30.4121 103.943L45.1213 103.943L45.1213 89.2341L30.4121 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 74.5247L30.4121 89.2339L45.1213 89.2339L45.1213 74.5247L30.4121 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 59.823L30.4121 74.5322L45.1213 74.5322L45.1213 59.823L30.4121 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 45.1135L30.4121 59.8228L45.1213 59.8228L45.1213 45.1135L30.4121 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 30.4114L30.4121 45.1206L45.1213 45.1206L45.1213 30.4114L30.4121 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 15.7024L30.4121 30.4116L45.1213 30.4116L45.1213 15.7024L30.4121 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4121 1.00026L30.4121 15.7095L45.1213 15.7095L45.1213 1.00026L30.4121 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 368.646L45.1211 383.355L59.8303 383.355L59.8303 368.646L45.1211 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 353.936L45.1211 368.646L59.8303 368.646L59.8303 353.936L45.1211 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 339.234L45.1211 353.943L59.8303 353.943L59.8303 339.234L45.1211 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 324.525L45.1211 339.234L59.8303 339.234L59.8303 324.525L45.1211 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 309.823L45.1211 324.532L59.8303 324.532L59.8303 309.823L45.1211 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 295.114L45.1211 309.823L59.8303 309.823L59.8303 295.114L45.1211 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 280.411L45.1211 295.121L59.8303 295.121L59.8303 280.411L45.1211 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 265.702L45.1211 280.411L59.8303 280.411L59.8303 265.702L45.1211 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 251L45.1211 265.709L59.8303 265.709L59.8303 251L45.1211 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 236.291L45.1211 251L59.8303 251L59.8303 236.291L45.1211 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 221.589L45.1211 236.298L59.8303 236.298L59.8303 221.589L45.1211 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 206.88L45.1211 221.589L59.8303 221.589L59.8303 206.88L45.1211 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 192.178L45.1211 206.887L59.8303 206.887L59.8303 192.178L45.1211 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 177.468L45.1211 192.177L59.8303 192.177L59.8303 177.468L45.1211 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 162.766L45.1211 177.475L59.8303 177.475L59.8303 162.766L45.1211 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 148.057L45.1211 162.766L59.8303 162.766L59.8303 148.057L45.1211 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 133.355L45.1211 148.064L59.8303 148.064L59.8303 133.355L45.1211 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 118.645L45.1211 133.354L59.8303 133.354L59.8303 118.645L45.1211 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 103.936L45.1211 118.646L59.8303 118.646L59.8303 103.936L45.1211 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 89.2341L45.1211 103.943L59.8303 103.943L59.8303 89.2341L45.1211 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 74.5247L45.1211 89.2339L59.8303 89.2339L59.8303 74.5247L45.1211 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 59.823L45.1211 74.5322L59.8303 74.5322L59.8303 59.823L45.1211 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 45.1135L45.1211 59.8228L59.8303 59.8228L59.8303 45.1135L45.1211 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 30.4114L45.1211 45.1206L59.8303 45.1206L59.8303 30.4114L45.1211 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 15.7024L45.1211 30.4116L59.8303 30.4116L59.8303 15.7024L45.1211 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 1.00026L45.1211 15.7095L59.8303 15.7095L59.8303 1.00026L45.1211 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 368.646L59.8223 383.355L74.5315 383.355L74.5315 368.646L59.8223 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 353.936L59.8223 368.646L74.5315 368.646L74.5315 353.936L59.8223 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 339.234L59.8223 353.943L74.5315 353.943L74.5315 339.234L59.8223 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 324.525L59.8223 339.234L74.5315 339.234L74.5315 324.525L59.8223 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 309.823L59.8223 324.532L74.5315 324.532L74.5315 309.823L59.8223 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 295.114L59.8223 309.823L74.5315 309.823L74.5315 295.114L59.8223 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 280.411L59.8223 295.121L74.5315 295.121L74.5315 280.411L59.8223 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 265.702L59.8223 280.411L74.5315 280.411L74.5315 265.702L59.8223 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 251L59.8223 265.709L74.5315 265.709L74.5315 251L59.8223 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 236.291L59.8223 251L74.5315 251L74.5315 236.291L59.8223 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 221.589L59.8223 236.298L74.5315 236.298L74.5315 221.589L59.8223 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 206.88L59.8223 221.589L74.5315 221.589L74.5315 206.88L59.8223 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 192.178L59.8223 206.887L74.5315 206.887L74.5315 192.178L59.8223 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 177.468L59.8223 192.177L74.5315 192.177L74.5315 177.468L59.8223 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 162.766L59.8223 177.475L74.5315 177.475L74.5315 162.766L59.8223 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 148.057L59.8223 162.766L74.5315 162.766L74.5315 148.057L59.8223 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 133.355L59.8223 148.064L74.5315 148.064L74.5315 133.355L59.8223 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 118.645L59.8223 133.354L74.5315 133.354L74.5315 118.645L59.8223 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 103.936L59.8223 118.646L74.5315 118.646L74.5315 103.936L59.8223 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 89.2341L59.8223 103.943L74.5315 103.943L74.5315 89.2341L59.8223 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 74.5247L59.8223 89.2339L74.5315 89.2339L74.5315 74.5247L59.8223 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 59.823L59.8223 74.5322L74.5315 74.5322L74.5315 59.823L59.8223 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 45.1135L59.8223 59.8228L74.5315 59.8228L74.5315 45.1135L59.8223 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 30.4114L59.8223 45.1206L74.5315 45.1206L74.5315 30.4114L59.8223 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 15.7024L59.8223 30.4116L74.5315 30.4116L74.5315 15.7024L59.8223 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8223 1.00026L59.8223 15.7095L74.5315 15.7095L74.5315 1.00026L59.8223 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 368.646L74.5312 383.355L89.2405 383.355L89.2405 368.646L74.5312 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 353.936L74.5312 368.646L89.2405 368.646L89.2405 353.936L74.5312 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 339.234L74.5312 353.943L89.2405 353.943L89.2405 339.234L74.5312 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 324.525L74.5312 339.234L89.2405 339.234L89.2405 324.525L74.5312 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 309.823L74.5312 324.532L89.2405 324.532L89.2405 309.823L74.5312 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 295.114L74.5312 309.823L89.2405 309.823L89.2405 295.114L74.5312 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 280.411L74.5312 295.121L89.2405 295.121L89.2405 280.411L74.5312 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 265.702L74.5312 280.411L89.2405 280.411L89.2405 265.702L74.5312 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 251L74.5312 265.709L89.2405 265.709L89.2405 251L74.5312 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 236.291L74.5312 251L89.2405 251L89.2405 236.291L74.5312 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 221.589L74.5312 236.298L89.2405 236.298L89.2405 221.589L74.5312 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 206.88L74.5312 221.589L89.2405 221.589L89.2405 206.88L74.5312 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 192.178L74.5312 206.887L89.2405 206.887L89.2405 192.178L74.5312 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 177.468L74.5312 192.177L89.2405 192.177L89.2405 177.468L74.5312 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 162.766L74.5312 177.475L89.2405 177.475L89.2405 162.766L74.5312 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 148.057L74.5312 162.766L89.2405 162.766L89.2405 148.057L74.5312 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 133.355L74.5312 148.064L89.2405 148.064L89.2405 133.355L74.5312 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 118.645L74.5312 133.354L89.2405 133.354L89.2405 118.645L74.5312 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 103.936L74.5312 118.646L89.2405 118.646L89.2405 103.936L74.5312 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 89.2341L74.5312 103.943L89.2405 103.943L89.2405 89.2341L74.5312 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 74.5247L74.5312 89.2339L89.2405 89.2339L89.2405 74.5247L74.5312 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 59.823L74.5312 74.5322L89.2405 74.5322L89.2405 59.823L74.5312 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 45.1135L74.5312 59.8228L89.2405 59.8228L89.2405 45.1135L74.5312 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 30.4114L74.5312 45.1206L89.2405 45.1206L89.2405 30.4114L74.5312 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 15.7024L74.5312 30.4116L89.2405 30.4116L89.2405 15.7024L74.5312 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 1.00026L74.5312 15.7095L89.2405 15.7095L89.2405 1.00026L74.5312 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 368.646L89.2344 383.355L103.944 383.355L103.944 368.646L89.2344 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 353.936L89.2344 368.646L103.944 368.646L103.944 353.936L89.2344 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 339.234L89.2344 353.943L103.944 353.943L103.944 339.234L89.2344 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 324.525L89.2344 339.234L103.944 339.234L103.944 324.525L89.2344 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 309.823L89.2344 324.532L103.944 324.532L103.944 309.823L89.2344 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 295.114L89.2344 309.823L103.944 309.823L103.944 295.114L89.2344 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 280.411L89.2344 295.121L103.944 295.121L103.944 280.411L89.2344 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 265.702L89.2344 280.412L103.944 280.412L103.944 265.702L89.2344 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 251L89.2344 265.709L103.944 265.709L103.944 251L89.2344 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 236.291L89.2344 251L103.944 251L103.944 236.291L89.2344 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 221.589L89.2344 236.298L103.944 236.298L103.944 221.589L89.2344 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 206.88L89.2344 221.589L103.944 221.589L103.944 206.88L89.2344 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 192.178L89.2344 206.887L103.944 206.887L103.944 192.178L89.2344 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 177.468L89.2344 192.177L103.944 192.177L103.944 177.468L89.2344 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 162.766L89.2344 177.475L103.944 177.475L103.944 162.766L89.2344 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 148.057L89.2344 162.766L103.944 162.766L103.944 148.057L89.2344 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 133.355L89.2344 148.064L103.944 148.064L103.944 133.355L89.2344 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 118.645L89.2344 133.354L103.944 133.354L103.944 118.645L89.2344 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 103.936L89.2344 118.646L103.944 118.646L103.944 103.936L89.2344 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 89.2341L89.2344 103.943L103.944 103.943L103.944 89.2341L89.2344 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 74.5247L89.2344 89.2339L103.944 89.2339L103.944 74.5247L89.2344 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 59.823L89.2344 74.5322L103.944 74.5322L103.944 59.823L89.2344 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 45.1135L89.2344 59.8228L103.944 59.8228L103.944 45.1135L89.2344 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 30.4114L89.2344 45.1206L103.944 45.1206L103.944 30.4114L89.2344 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 15.7024L89.2344 30.4116L103.944 30.4116L103.944 15.7024L89.2344 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2344 1.00026L89.2344 15.7095L103.944 15.7095L103.944 1.00026L89.2344 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 368.646L103.943 383.355L118.652 383.355L118.652 368.646L103.943 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 353.936L103.943 368.646L118.652 368.646L118.652 353.936L103.943 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 339.234L103.943 353.943L118.652 353.943L118.652 339.234L103.943 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 324.525L103.943 339.234L118.652 339.234L118.652 324.525L103.943 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 309.823L103.943 324.532L118.652 324.532L118.652 309.823L103.943 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 295.114L103.943 309.823L118.652 309.823L118.652 295.114L103.943 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 280.411L103.943 295.121L118.652 295.121L118.652 280.411L103.943 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 265.702L103.943 280.411L118.652 280.411L118.652 265.702L103.943 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 251L103.943 265.709L118.652 265.709L118.652 251L103.943 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 236.291L103.943 251L118.652 251L118.652 236.291L103.943 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 221.589L103.943 236.298L118.652 236.298L118.652 221.589L103.943 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 206.88L103.943 221.589L118.652 221.589L118.652 206.88L103.943 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 192.178L103.943 206.887L118.652 206.887L118.652 192.178L103.943 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 177.468L103.943 192.177L118.652 192.177L118.652 177.468L103.943 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 162.766L103.943 177.475L118.652 177.475L118.652 162.766L103.943 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 148.057L103.943 162.766L118.652 162.766L118.652 148.057L103.943 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 133.355L103.943 148.064L118.652 148.064L118.652 133.355L103.943 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 118.645L103.943 133.354L118.652 133.354L118.652 118.645L103.943 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 103.936L103.943 118.646L118.652 118.646L118.652 103.936L103.943 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 89.2341L103.943 103.943L118.652 103.943L118.652 89.2341L103.943 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 74.5251L103.943 89.2344L118.652 89.2344L118.652 74.5251L103.943 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 59.823L103.943 74.5322L118.652 74.5322L118.652 59.823L103.943 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 45.1135L103.943 59.8228L118.652 59.8228L118.652 45.1135L103.943 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 30.4114L103.943 45.1206L118.652 45.1206L118.652 30.4114L103.943 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 15.7024L103.943 30.4116L118.652 30.4116L118.652 15.7024L103.943 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.943 1.00026L103.943 15.7095L118.652 15.7095L118.652 1.00026L103.943 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 368.646L118.645 383.355L133.354 383.355L133.354 368.646L118.645 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 353.936L118.645 368.646L133.354 368.646L133.354 353.936L118.645 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 339.234L118.645 353.943L133.354 353.943L133.354 339.234L118.645 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 324.525L118.645 339.234L133.354 339.234L133.354 324.525L118.645 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 309.823L118.645 324.532L133.354 324.532L133.354 309.823L118.645 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 295.114L118.645 309.823L133.354 309.823L133.354 295.114L118.645 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 280.411L118.645 295.121L133.354 295.121L133.354 280.411L118.645 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 265.702L118.645 280.412L133.354 280.412L133.354 265.702L118.645 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 251L118.645 265.709L133.354 265.709L133.354 251L118.645 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 236.291L118.645 251L133.354 251L133.354 236.291L118.645 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 221.589L118.645 236.298L133.354 236.298L133.354 221.589L118.645 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 206.88L118.645 221.589L133.354 221.589L133.354 206.88L118.645 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 192.178L118.645 206.887L133.354 206.887L133.354 192.178L118.645 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 177.468L118.645 192.177L133.354 192.177L133.354 177.468L118.645 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 162.766L118.645 177.475L133.354 177.475L133.354 162.766L118.645 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 148.057L118.645 162.766L133.354 162.766L133.354 148.057L118.645 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 133.355L118.645 148.064L133.354 148.064L133.354 133.355L118.645 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 118.645L118.645 133.354L133.354 133.354L133.354 118.645L118.645 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 103.936L118.645 118.646L133.354 118.646L133.354 103.936L118.645 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 89.2341L118.645 103.943L133.354 103.943L133.354 89.2341L118.645 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 74.5247L118.645 89.2339L133.354 89.2339L133.354 74.5247L118.645 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 59.823L118.645 74.5322L133.354 74.5322L133.354 59.823L118.645 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 45.1135L118.645 59.8228L133.354 59.8228L133.354 45.1135L118.645 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 30.4114L118.645 45.1206L133.354 45.1206L133.354 30.4114L118.645 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 15.7024L118.645 30.4116L133.354 30.4116L133.354 15.7024L118.645 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.645 1.00026L118.645 15.7095L133.354 15.7095L133.354 1.00026L118.645 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 368.646L133.354 383.355L148.063 383.355L148.063 368.646L133.354 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 353.936L133.354 368.646L148.063 368.646L148.063 353.936L133.354 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 339.234L133.354 353.943L148.063 353.943L148.063 339.234L133.354 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 324.525L133.354 339.234L148.063 339.234L148.063 324.525L133.354 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 309.823L133.354 324.532L148.063 324.532L148.063 309.823L133.354 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 295.114L133.354 309.823L148.063 309.823L148.063 295.114L133.354 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 280.411L133.354 295.121L148.063 295.121L148.063 280.411L133.354 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 265.702L133.354 280.412L148.063 280.412L148.063 265.702L133.354 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 251L133.354 265.709L148.063 265.709L148.063 251L133.354 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 236.291L133.354 251L148.063 251L148.063 236.291L133.354 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 221.589L133.354 236.298L148.063 236.298L148.063 221.589L133.354 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 206.88L133.354 221.589L148.063 221.589L148.063 206.88L133.354 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 192.178L133.354 206.887L148.063 206.887L148.063 192.178L133.354 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 177.468L133.354 192.177L148.063 192.177L148.063 177.468L133.354 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 162.766L133.354 177.475L148.063 177.475L148.063 162.766L133.354 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 148.057L133.354 162.766L148.063 162.766L148.063 148.057L133.354 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 133.355L133.354 148.064L148.063 148.064L148.063 133.355L133.354 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 118.645L133.354 133.354L148.063 133.354L148.063 118.645L133.354 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 103.936L133.354 118.646L148.063 118.646L148.063 103.936L133.354 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 89.2341L133.354 103.943L148.063 103.943L148.063 89.2341L133.354 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 74.5247L133.354 89.2339L148.063 89.2339L148.063 74.5247L133.354 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 59.823L133.354 74.5322L148.063 74.5322L148.063 59.823L133.354 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 45.1135L133.354 59.8228L148.063 59.8228L148.063 45.1135L133.354 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 30.4114L133.354 45.1206L148.063 45.1206L148.063 30.4114L133.354 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 15.7024L133.354 30.4116L148.063 30.4116L148.063 15.7024L133.354 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.354 1.00026L133.354 15.7095L148.063 15.7095L148.063 1.00026L133.354 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 368.646L148.057 383.355L162.766 383.355L162.766 368.646L148.057 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 353.936L148.057 368.646L162.766 368.646L162.766 353.936L148.057 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 339.234L148.057 353.943L162.766 353.943L162.766 339.234L148.057 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 324.525L148.057 339.234L162.766 339.234L162.766 324.525L148.057 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 309.823L148.057 324.532L162.766 324.532L162.766 309.823L148.057 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 295.114L148.057 309.823L162.766 309.823L162.766 295.114L148.057 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 280.411L148.057 295.121L162.766 295.121L162.766 280.411L148.057 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 265.702L148.057 280.411L162.766 280.411L162.766 265.702L148.057 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 251L148.057 265.709L162.766 265.709L162.766 251L148.057 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 236.291L148.057 251L162.766 251L162.766 236.291L148.057 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 221.589L148.057 236.298L162.766 236.298L162.766 221.589L148.057 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 206.88L148.057 221.589L162.766 221.589L162.766 206.88L148.057 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 192.178L148.057 206.887L162.766 206.887L162.766 192.178L148.057 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 177.468L148.057 192.177L162.766 192.177L162.766 177.468L148.057 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 162.766L148.057 177.475L162.766 177.475L162.766 162.766L148.057 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 148.057L148.057 162.766L162.766 162.766L162.766 148.057L148.057 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 133.355L148.057 148.064L162.766 148.064L162.766 133.355L148.057 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 118.645L148.057 133.354L162.766 133.354L162.766 118.645L148.057 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 103.936L148.057 118.646L162.766 118.646L162.766 103.936L148.057 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 89.2341L148.057 103.943L162.766 103.943L162.766 89.2341L148.057 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 74.5251L148.057 89.2344L162.766 89.2344L162.766 74.5251L148.057 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 59.823L148.057 74.5322L162.766 74.5322L162.766 59.823L148.057 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 45.1135L148.057 59.8228L162.766 59.8228L162.766 45.1135L148.057 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 30.4114L148.057 45.1206L162.766 45.1206L162.766 30.4114L148.057 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 15.7024L148.057 30.4116L162.766 30.4116L162.766 15.7024L148.057 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 1.00026L148.057 15.7095L162.766 15.7095L162.766 1.00026L148.057 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 368.646L162.766 383.355L177.475 383.355L177.475 368.646L162.766 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 353.936L162.766 368.646L177.475 368.646L177.475 353.936L162.766 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 339.234L162.766 353.943L177.475 353.943L177.475 339.234L162.766 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 324.525L162.766 339.234L177.475 339.234L177.475 324.525L162.766 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 309.823L162.766 324.532L177.475 324.532L177.475 309.823L162.766 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 295.114L162.766 309.823L177.475 309.823L177.475 295.114L162.766 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 280.411L162.766 295.121L177.475 295.121L177.475 280.411L162.766 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 265.702L162.766 280.411L177.475 280.411L177.475 265.702L162.766 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 251L162.766 265.709L177.475 265.709L177.475 251L162.766 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 236.291L162.766 251L177.475 251L177.475 236.291L162.766 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 221.589L162.766 236.298L177.475 236.298L177.475 221.589L162.766 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 206.88L162.766 221.589L177.475 221.589L177.475 206.88L162.766 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 192.178L162.766 206.887L177.475 206.887L177.475 192.178L162.766 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 177.468L162.766 192.177L177.475 192.177L177.475 177.468L162.766 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 162.766L162.766 177.475L177.475 177.475L177.475 162.766L162.766 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 148.057L162.766 162.766L177.475 162.766L177.475 148.057L162.766 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 133.355L162.766 148.064L177.475 148.064L177.475 133.355L162.766 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 118.646L162.766 133.355L177.475 133.355L177.475 118.646L162.766 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 103.936L162.766 118.646L177.475 118.646L177.475 103.936L162.766 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 89.2341L162.766 103.943L177.475 103.943L177.475 89.2341L162.766 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 74.5251L162.766 89.2344L177.475 89.2344L177.475 74.5251L162.766 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 59.823L162.766 74.5322L177.475 74.5322L177.475 59.823L162.766 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 45.1135L162.766 59.8228L177.475 59.8228L177.475 45.1135L162.766 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 30.4114L162.766 45.1206L177.475 45.1206L177.475 30.4114L162.766 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 15.7024L162.766 30.4116L177.475 30.4116L177.475 15.7024L162.766 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 1.00026L162.766 15.7095L177.475 15.7095L177.475 1.00026L162.766 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 368.646L177.469 383.355L192.178 383.355L192.178 368.646L177.469 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 353.936L177.469 368.646L192.178 368.646L192.178 353.936L177.469 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 339.234L177.469 353.943L192.178 353.943L192.178 339.234L177.469 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 324.525L177.469 339.234L192.178 339.234L192.178 324.525L177.469 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 309.823L177.469 324.532L192.178 324.532L192.178 309.823L177.469 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 295.114L177.469 309.823L192.178 309.823L192.178 295.114L177.469 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 280.411L177.469 295.121L192.178 295.121L192.178 280.411L177.469 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 265.702L177.469 280.411L192.178 280.411L192.178 265.702L177.469 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 251L177.469 265.709L192.178 265.709L192.178 251L177.469 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 236.291L177.469 251L192.178 251L192.178 236.291L177.469 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 221.589L177.469 236.298L192.178 236.298L192.178 221.589L177.469 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 206.88L177.469 221.589L192.178 221.589L192.178 206.88L177.469 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 192.178L177.469 206.887L192.178 206.887L192.178 192.178L177.469 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 177.468L177.469 192.177L192.178 192.177L192.178 177.468L177.469 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 162.766L177.469 177.475L192.178 177.475L192.178 162.766L177.469 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 148.057L177.469 162.766L192.178 162.766L192.178 148.057L177.469 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 133.355L177.469 148.064L192.178 148.064L192.178 133.355L177.469 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 118.646L177.469 133.355L192.178 133.355L192.178 118.646L177.469 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 103.936L177.469 118.646L192.178 118.646L192.178 103.936L177.469 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 89.2341L177.469 103.943L192.178 103.943L192.178 89.2341L177.469 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 74.5247L177.469 89.2339L192.178 89.2339L192.178 74.5247L177.469 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 59.823L177.469 74.5322L192.178 74.5322L192.178 59.823L177.469 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 45.1135L177.469 59.8228L192.178 59.8228L192.178 45.1135L177.469 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 30.4114L177.469 45.1206L192.178 45.1206L192.178 30.4114L177.469 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 15.7024L177.469 30.4116L192.178 30.4116L192.178 15.7024L177.469 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.469 1.00026L177.469 15.7095L192.178 15.7095L192.178 1.00026L177.469 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 368.646L192.178 383.355L206.887 383.355L206.887 368.646L192.178 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 353.936L192.178 368.646L206.887 368.646L206.887 353.936L192.178 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 339.234L192.178 353.943L206.887 353.943L206.887 339.234L192.178 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 324.525L192.178 339.234L206.887 339.234L206.887 324.525L192.178 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 309.823L192.178 324.532L206.887 324.532L206.887 309.823L192.178 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 295.114L192.178 309.823L206.887 309.823L206.887 295.114L192.178 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 280.411L192.178 295.121L206.887 295.121L206.887 280.411L192.178 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 265.702L192.178 280.411L206.887 280.411L206.887 265.702L192.178 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 251L192.178 265.709L206.887 265.709L206.887 251L192.178 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 236.291L192.178 251L206.887 251L206.887 236.291L192.178 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 221.589L192.178 236.298L206.887 236.298L206.887 221.589L192.178 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 206.88L192.178 221.589L206.887 221.589L206.887 206.88L192.178 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 192.178L192.178 206.887L206.887 206.887L206.887 192.178L192.178 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 177.468L192.178 192.177L206.887 192.177L206.887 177.468L192.178 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 162.766L192.178 177.475L206.887 177.475L206.887 162.766L192.178 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 148.057L192.178 162.766L206.887 162.766L206.887 148.057L192.178 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 133.355L192.178 148.064L206.887 148.064L206.887 133.355L192.178 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 118.646L192.178 133.355L206.887 133.355L206.887 118.646L192.178 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 103.936L192.178 118.646L206.887 118.646L206.887 103.936L192.178 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 89.2341L192.178 103.943L206.887 103.943L206.887 89.2341L192.178 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 74.5247L192.178 89.2339L206.887 89.2339L206.887 74.5247L192.178 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 59.823L192.178 74.5322L206.887 74.5322L206.887 59.823L192.178 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 45.1135L192.178 59.8228L206.887 59.8228L206.887 45.1135L192.178 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 30.4114L192.178 45.1206L206.887 45.1206L206.887 30.4114L192.178 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 15.7024L192.178 30.4116L206.887 30.4116L206.887 15.7024L192.178 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.178 1.00026L192.178 15.7095L206.887 15.7095L206.887 1.00026L192.178 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 368.646L206.879 383.355L221.588 383.355L221.588 368.646L206.879 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 353.936L206.879 368.646L221.588 368.646L221.588 353.936L206.879 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 339.234L206.879 353.943L221.588 353.943L221.588 339.234L206.879 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 324.525L206.879 339.234L221.588 339.234L221.588 324.525L206.879 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 309.823L206.879 324.532L221.588 324.532L221.588 309.823L206.879 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 295.114L206.879 309.823L221.588 309.823L221.588 295.114L206.879 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 280.411L206.879 295.121L221.588 295.121L221.588 280.411L206.879 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 265.702L206.879 280.411L221.588 280.411L221.588 265.702L206.879 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 251L206.879 265.709L221.588 265.709L221.588 251L206.879 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 236.291L206.879 251L221.588 251L221.588 236.291L206.879 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 221.589L206.879 236.298L221.588 236.298L221.588 221.589L206.879 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 206.88L206.879 221.589L221.588 221.589L221.588 206.88L206.879 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 192.178L206.879 206.887L221.588 206.887L221.588 192.178L206.879 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 177.468L206.879 192.177L221.588 192.177L221.588 177.468L206.879 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 162.766L206.879 177.475L221.588 177.475L221.588 162.766L206.879 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 148.057L206.879 162.766L221.588 162.766L221.588 148.057L206.879 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 133.355L206.879 148.064L221.588 148.064L221.588 133.355L206.879 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 118.646L206.879 133.355L221.588 133.355L221.588 118.646L206.879 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 103.936L206.879 118.646L221.588 118.646L221.588 103.936L206.879 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 89.2341L206.879 103.943L221.588 103.943L221.588 89.2341L206.879 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 74.5247L206.879 89.2339L221.588 89.2339L221.588 74.5247L206.879 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 59.823L206.879 74.5322L221.588 74.5322L221.588 59.823L206.879 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 45.1135L206.879 59.8228L221.588 59.8228L221.588 45.1135L206.879 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 30.4114L206.879 45.1206L221.588 45.1206L221.588 30.4114L206.879 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 15.7024L206.879 30.4116L221.588 30.4116L221.588 15.7024L206.879 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 1.00026L206.879 15.7095L221.588 15.7095L221.588 1.00026L206.879 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 368.646L221.59 383.355L236.299 383.355L236.299 368.646L221.59 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 353.936L221.588 368.646L236.297 368.646L236.297 353.936L221.588 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 339.234L221.588 353.943L236.297 353.943L236.297 339.234L221.588 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 324.525L221.588 339.234L236.297 339.234L236.297 324.525L221.588 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 309.823L221.588 324.532L236.297 324.532L236.297 309.823L221.588 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 295.114L221.588 309.823L236.297 309.823L236.297 295.114L221.588 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 280.411L221.588 295.121L236.297 295.121L236.297 280.411L221.588 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 265.702L221.588 280.411L236.297 280.411L236.297 265.702L221.588 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 251L221.588 265.709L236.297 265.709L236.297 251L221.588 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 236.291L221.588 251L236.297 251L236.297 236.291L221.588 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 221.589L221.59 236.298L236.299 236.298L236.299 221.589L221.59 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 206.88L221.59 221.589L236.299 221.589L236.299 206.88L221.59 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 192.178L221.59 206.887L236.299 206.887L236.299 192.178L221.59 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 177.468L221.59 192.177L236.299 192.177L236.299 177.468L221.59 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 162.766L221.59 177.475L236.299 177.475L236.299 162.766L221.59 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 148.057L221.59 162.766L236.299 162.766L236.299 148.057L221.59 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 133.355L221.59 148.064L236.299 148.064L236.299 133.355L221.59 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 118.646L221.59 133.355L236.299 133.355L236.299 118.646L221.59 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 103.936L221.59 118.646L236.299 118.646L236.299 103.936L221.59 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 89.2341L221.59 103.943L236.299 103.943L236.299 89.2341L221.59 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 74.5247L221.59 89.2339L236.299 89.2339L236.299 74.5247L221.59 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 59.823L221.59 74.5322L236.299 74.5322L236.299 59.823L221.59 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 45.1135L221.59 59.8228L236.299 59.8228L236.299 45.1135L221.59 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59 30.4114L221.59 45.1206L236.299 45.1206L236.299 30.4114L221.59 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 15.7024L221.588 30.4116L236.297 30.4116L236.297 15.7024L221.588 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.588 1.00026L221.588 15.7095L236.297 15.7095L236.297 1.00026L221.588 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 368.646L236.291 383.355L251 383.355L251 368.646L236.291 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 353.936L236.291 368.646L251 368.646L251 353.936L236.291 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 339.234L236.291 353.943L251 353.943L251 339.234L236.291 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 324.525L236.291 339.234L251 339.234L251 324.525L236.291 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 309.823L236.291 324.532L251 324.532L251 309.823L236.291 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 295.114L236.291 309.823L251 309.823L251 295.114L236.291 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 280.411L236.291 295.121L251 295.121L251 280.411L236.291 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 265.702L236.291 280.411L251 280.411L251 265.702L236.291 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 251L236.291 265.709L251 265.709L251 251L236.291 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 236.291L236.291 251L251 251L251 236.291L236.291 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 221.589L236.291 236.298L251 236.298L251 221.589L236.291 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 206.88L236.291 221.589L251 221.589L251 206.88L236.291 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 192.178L236.291 206.887L251 206.887L251 192.178L236.291 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 177.468L236.291 192.177L251 192.177L251 177.468L236.291 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 162.766L236.291 177.475L251 177.475L251 162.766L236.291 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 148.057L236.291 162.766L251 162.766L251 148.057L236.291 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 133.355L236.291 148.064L251 148.064L251 133.355L236.291 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 118.645L236.291 133.354L251 133.354L251 118.645L236.291 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 103.936L236.291 118.646L251 118.646L251 103.936L236.291 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 89.2341L236.291 103.943L251 103.943L251 89.2341L236.291 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 74.5251L236.291 89.2344L251 89.2344L251 74.5251L236.291 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 59.823L236.291 74.5322L251 74.5322L251 59.823L236.291 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 45.1135L236.291 59.8228L251 59.8228L251 45.1135L236.291 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 30.4114L236.291 45.1206L251 45.1206L251 30.4114L236.291 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 15.7024L236.291 30.4116L251 30.4116L251 15.7024L236.291 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.291 1.00026L236.291 15.7095L251 15.7095L251 1.00026L236.291 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 368.646L251 383.355L265.709 383.355L265.709 368.646L251 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 353.936L251 368.646L265.709 368.646L265.709 353.936L251 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 339.234L251 353.943L265.709 353.943L265.709 339.234L251 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 324.525L251 339.234L265.709 339.234L265.709 324.525L251 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 309.823L251 324.532L265.709 324.532L265.709 309.823L251 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 295.114L251 309.823L265.709 309.823L265.709 295.114L251 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 280.411L251 295.121L265.709 295.121L265.709 280.411L251 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 265.702L251 280.411L265.709 280.411L265.709 265.702L251 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 251L251 265.709L265.709 265.709L265.709 251L251 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 236.291L251 251L265.709 251L265.709 236.291L251 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 221.589L251 236.298L265.709 236.298L265.709 221.589L251 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 206.88L251 221.589L265.709 221.589L265.709 206.88L251 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 192.178L251 206.887L265.709 206.887L265.709 192.178L251 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 177.468L251 192.177L265.709 192.177L265.709 177.468L251 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 162.766L251 177.475L265.709 177.475L265.709 162.766L251 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 148.057L251 162.766L265.709 162.766L265.709 148.057L251 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 133.355L251 148.064L265.709 148.064L265.709 133.355L251 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 118.645L251 133.354L265.709 133.354L265.709 118.645L251 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 103.936L251 118.646L265.709 118.646L265.709 103.936L251 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 89.2341L251 103.943L265.709 103.943L265.709 89.2341L251 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 74.5251L251 89.2344L265.709 89.2344L265.709 74.5251L251 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 59.823L251 74.5322L265.709 74.5322L265.709 59.823L251 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 45.1135L251 59.8228L265.709 59.8228L265.709 45.1135L251 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 30.4114L251 45.1206L265.709 45.1206L265.709 30.4114L251 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 15.7024L251 30.4116L265.709 30.4116L265.709 15.7024L251 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 1.00026L251 15.7095L265.709 15.7095L265.709 1.00026L251 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 368.646L265.709 383.355L280.418 383.355L280.418 368.646L265.709 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 353.936L265.709 368.646L280.418 368.646L280.418 353.936L265.709 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 339.234L265.709 353.943L280.418 353.943L280.418 339.234L265.709 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 324.525L265.709 339.234L280.418 339.234L280.418 324.525L265.709 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 309.823L265.709 324.532L280.418 324.532L280.418 309.823L265.709 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 295.114L265.709 309.823L280.418 309.823L280.418 295.114L265.709 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 280.411L265.709 295.121L280.418 295.121L280.418 280.411L265.709 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 265.702L265.709 280.412L280.418 280.412L280.418 265.702L265.709 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 251L265.709 265.709L280.418 265.709L280.418 251L265.709 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 236.291L265.709 251L280.418 251L280.418 236.291L265.709 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 221.589L265.709 236.298L280.418 236.298L280.418 221.589L265.709 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 206.88L265.709 221.589L280.418 221.589L280.418 206.88L265.709 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 192.178L265.709 206.887L280.418 206.887L280.418 192.178L265.709 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 177.468L265.709 192.177L280.418 192.177L280.418 177.468L265.709 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 162.766L265.709 177.475L280.418 177.475L280.418 162.766L265.709 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 148.057L265.709 162.766L280.418 162.766L280.418 148.057L265.709 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 133.355L265.709 148.064L280.418 148.064L280.418 133.355L265.709 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 118.646L265.709 133.355L280.418 133.355L280.418 118.646L265.709 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 103.936L265.709 118.646L280.418 118.646L280.418 103.936L265.709 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 89.2341L265.709 103.943L280.418 103.943L280.418 89.2341L265.709 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 74.5247L265.709 89.2339L280.418 89.2339L280.418 74.5247L265.709 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 59.823L265.709 74.5322L280.418 74.5322L280.418 59.823L265.709 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 45.1135L265.709 59.8228L280.418 59.8228L280.418 45.1135L265.709 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 30.4114L265.709 45.1206L280.418 45.1206L280.418 30.4114L265.709 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 15.7024L265.709 30.4116L280.418 30.4116L280.418 15.7024L265.709 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.709 1.00026L265.709 15.7095L280.418 15.7095L280.418 1.00026L265.709 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 368.646L280.412 383.355L295.121 383.355L295.121 368.646L280.412 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 353.936L280.412 368.646L295.121 368.646L295.121 353.936L280.412 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 339.234L280.412 353.943L295.121 353.943L295.121 339.234L280.412 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 324.525L280.412 339.234L295.121 339.234L295.121 324.525L280.412 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 309.823L280.412 324.532L295.121 324.532L295.121 309.823L280.412 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 295.114L280.412 309.823L295.121 309.823L295.121 295.114L280.412 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 280.411L280.412 295.121L295.121 295.121L295.121 280.411L280.412 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 265.702L280.412 280.412L295.121 280.412L295.121 265.702L280.412 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 251L280.412 265.709L295.121 265.709L295.121 251L280.412 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 236.291L280.412 251L295.121 251L295.121 236.291L280.412 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 221.589L280.412 236.298L295.121 236.298L295.121 221.589L280.412 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 206.88L280.412 221.589L295.121 221.589L295.121 206.88L280.412 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 192.178L280.412 206.887L295.121 206.887L295.121 192.178L280.412 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 177.468L280.412 192.177L295.121 192.177L295.121 177.468L280.412 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 162.766L280.412 177.475L295.121 177.475L295.121 162.766L280.412 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 148.057L280.412 162.766L295.121 162.766L295.121 148.057L280.412 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 133.355L280.412 148.064L295.121 148.064L295.121 133.355L280.412 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 118.646L280.412 133.355L295.121 133.355L295.121 118.646L280.412 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 103.936L280.412 118.646L295.121 118.646L295.121 103.936L280.412 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 89.2341L280.412 103.943L295.121 103.943L295.121 89.2341L280.412 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 74.5247L280.412 89.2339L295.121 89.2339L295.121 74.5247L280.412 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 59.823L280.412 74.5322L295.121 74.5322L295.121 59.823L280.412 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 45.1135L280.412 59.8228L295.121 59.8228L295.121 45.1135L280.412 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 30.4114L280.412 45.1206L295.121 45.1206L295.121 30.4114L280.412 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 15.7024L280.412 30.4116L295.121 30.4116L295.121 15.7024L280.412 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 1.00026L280.412 15.7095L295.121 15.7095L295.121 1.00026L280.412 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 368.646L295.121 383.355L309.83 383.355L309.83 368.646L295.121 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 353.936L295.121 368.646L309.83 368.646L309.83 353.936L295.121 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 339.234L295.121 353.943L309.83 353.943L309.83 339.234L295.121 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 324.525L295.121 339.234L309.83 339.234L309.83 324.525L295.121 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 309.823L295.121 324.532L309.83 324.532L309.83 309.823L295.121 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 295.114L295.121 309.823L309.83 309.823L309.83 295.114L295.121 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 280.411L295.121 295.121L309.83 295.121L309.83 280.411L295.121 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 265.702L295.121 280.412L309.83 280.412L309.83 265.702L295.121 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 251L295.121 265.709L309.83 265.709L309.83 251L295.121 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 236.291L295.121 251L309.83 251L309.83 236.291L295.121 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 221.589L295.121 236.298L309.83 236.298L309.83 221.589L295.121 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 206.88L295.121 221.589L309.83 221.589L309.83 206.88L295.121 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 192.178L295.121 206.887L309.83 206.887L309.83 192.178L295.121 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 177.468L295.121 192.177L309.83 192.177L309.83 177.468L295.121 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 162.766L295.121 177.475L309.83 177.475L309.83 162.766L295.121 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 148.057L295.121 162.766L309.83 162.766L309.83 148.057L295.121 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 133.355L295.121 148.064L309.83 148.064L309.83 133.355L295.121 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 118.646L295.121 133.355L309.83 133.355L309.83 118.646L295.121 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 103.936L295.121 118.646L309.83 118.646L309.83 103.936L295.121 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 89.2341L295.121 103.943L309.83 103.943L309.83 89.2341L295.121 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 74.5247L295.121 89.2339L309.83 89.2339L309.83 74.5247L295.121 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 59.823L295.121 74.5322L309.83 74.5322L309.83 59.823L295.121 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 45.1135L295.121 59.8228L309.83 59.8228L309.83 45.1135L295.121 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 30.4114L295.121 45.1206L309.83 45.1206L309.83 30.4114L295.121 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 15.7024L295.121 30.4116L309.83 30.4116L309.83 15.7024L295.121 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.121 1.00026L295.121 15.7095L309.83 15.7095L309.83 1.00026L295.121 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 368.646L309.822 383.355L324.531 383.355L324.531 368.646L309.822 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 353.936L309.822 368.646L324.531 368.646L324.531 353.936L309.822 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 339.234L309.822 353.943L324.531 353.943L324.531 339.234L309.822 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 324.525L309.822 339.234L324.531 339.234L324.531 324.525L309.822 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 309.823L309.822 324.532L324.531 324.532L324.531 309.823L309.822 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 295.114L309.822 309.823L324.531 309.823L324.531 295.114L309.822 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 280.411L309.822 295.121L324.531 295.121L324.531 280.411L309.822 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 265.702L309.822 280.412L324.531 280.412L324.531 265.702L309.822 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 251L309.822 265.709L324.531 265.709L324.531 251L309.822 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 236.291L309.822 251L324.531 251L324.531 236.291L309.822 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 221.589L309.822 236.298L324.531 236.298L324.531 221.589L309.822 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 206.88L309.822 221.589L324.531 221.589L324.531 206.88L309.822 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 192.178L309.822 206.887L324.531 206.887L324.531 192.178L309.822 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 177.468L309.822 192.177L324.531 192.177L324.531 177.468L309.822 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 162.766L309.822 177.475L324.531 177.475L324.531 162.766L309.822 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 148.057L309.822 162.766L324.531 162.766L324.531 148.057L309.822 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 133.355L309.822 148.064L324.531 148.064L324.531 133.355L309.822 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 118.646L309.822 133.355L324.531 133.355L324.531 118.646L309.822 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 103.936L309.822 118.646L324.531 118.646L324.531 103.936L309.822 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 89.2341L309.822 103.943L324.531 103.943L324.531 89.2341L309.822 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 74.5247L309.822 89.2339L324.531 89.2339L324.531 74.5247L309.822 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 59.823L309.822 74.5322L324.531 74.5322L324.531 59.823L309.822 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 45.1135L309.822 59.8228L324.531 59.8228L324.531 45.1135L309.822 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 30.4114L309.822 45.1206L324.531 45.1206L324.531 30.4114L309.822 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 15.7024L309.822 30.4116L324.531 30.4116L324.531 15.7024L309.822 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.822 1.00026L309.822 15.7095L324.531 15.7095L324.531 1.00026L309.822 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 368.646L324.531 383.355L339.24 383.355L339.24 368.646L324.531 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 353.936L324.531 368.646L339.24 368.646L339.24 353.936L324.531 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 339.234L324.531 353.943L339.24 353.943L339.24 339.234L324.531 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 324.525L324.531 339.234L339.24 339.234L339.24 324.525L324.531 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 309.823L324.531 324.532L339.24 324.532L339.24 309.823L324.531 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 295.114L324.531 309.823L339.24 309.823L339.24 295.114L324.531 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 280.411L324.531 295.121L339.24 295.121L339.24 280.411L324.531 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 265.702L324.531 280.412L339.24 280.412L339.24 265.702L324.531 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 251L324.531 265.709L339.24 265.709L339.24 251L324.531 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 236.291L324.531 251L339.24 251L339.24 236.291L324.531 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 221.589L324.531 236.298L339.24 236.298L339.24 221.589L324.531 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 206.88L324.531 221.589L339.24 221.589L339.24 206.88L324.531 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 192.178L324.531 206.887L339.24 206.887L339.24 192.178L324.531 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 177.468L324.531 192.177L339.24 192.177L339.24 177.468L324.531 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 162.766L324.531 177.475L339.24 177.475L339.24 162.766L324.531 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 148.057L324.531 162.766L339.24 162.766L339.24 148.057L324.531 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 133.355L324.531 148.064L339.24 148.064L339.24 133.355L324.531 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 118.646L324.531 133.355L339.24 133.355L339.24 118.646L324.531 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 103.936L324.531 118.646L339.24 118.646L339.24 103.936L324.531 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 89.2341L324.531 103.943L339.24 103.943L339.24 89.2341L324.531 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 74.5247L324.531 89.2339L339.24 89.2339L339.24 74.5247L324.531 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 59.823L324.531 74.5322L339.24 74.5322L339.24 59.823L324.531 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 45.1135L324.531 59.8228L339.24 59.8228L339.24 45.1135L324.531 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 30.4114L324.531 45.1206L339.24 45.1206L339.24 30.4114L324.531 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 15.7024L324.531 30.4116L339.24 30.4116L339.24 15.7024L324.531 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531 1.00026L324.531 15.7095L339.24 15.7095L339.24 1.00026L324.531 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 368.646L339.234 383.355L353.944 383.355L353.944 368.646L339.234 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 353.936L339.234 368.646L353.944 368.646L353.944 353.936L339.234 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 339.234L339.234 353.943L353.944 353.943L353.944 339.234L339.234 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 324.525L339.234 339.234L353.944 339.234L353.944 324.525L339.234 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 309.823L339.234 324.532L353.944 324.532L353.944 309.823L339.234 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 295.114L339.234 309.823L353.944 309.823L353.944 295.114L339.234 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 280.411L339.234 295.121L353.944 295.121L353.944 280.411L339.234 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 265.702L339.234 280.412L353.944 280.412L353.944 265.702L339.234 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 251L339.234 265.709L353.944 265.709L353.944 251L339.234 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 236.291L339.234 251L353.944 251L353.944 236.291L339.234 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 221.589L339.234 236.298L353.944 236.298L353.944 221.589L339.234 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 206.88L339.234 221.589L353.944 221.589L353.944 206.88L339.234 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 192.178L339.234 206.887L353.944 206.887L353.944 192.178L339.234 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 177.468L339.234 192.177L353.944 192.177L353.944 177.468L339.234 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 162.766L339.234 177.475L353.944 177.475L353.944 162.766L339.234 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 148.057L339.234 162.766L353.944 162.766L353.944 148.057L339.234 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 133.355L339.234 148.064L353.944 148.064L353.944 133.355L339.234 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 118.646L339.234 133.355L353.944 133.355L353.944 118.646L339.234 118.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 103.936L339.234 118.646L353.944 118.646L353.944 103.936L339.234 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 89.2341L339.234 103.943L353.944 103.943L353.944 89.2341L339.234 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 74.5247L339.234 89.2339L353.944 89.2339L353.944 74.5247L339.234 74.5247Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 59.823L339.234 74.5322L353.944 74.5322L353.944 59.823L339.234 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 45.1135L339.234 59.8228L353.944 59.8228L353.944 45.1135L339.234 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 30.4114L339.234 45.1206L353.944 45.1206L353.944 30.4114L339.234 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 15.7024L339.234 30.4116L353.944 30.4116L353.944 15.7024L339.234 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.234 1.00026L339.234 15.7095L353.944 15.7095L353.944 1.00026L339.234 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 368.646L353.943 383.355L368.653 383.355L368.653 368.646L353.943 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 353.936L353.943 368.646L368.652 368.646L368.652 353.936L353.943 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 339.234L353.943 353.943L368.652 353.943L368.652 339.234L353.943 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 324.525L353.943 339.234L368.652 339.234L368.652 324.525L353.943 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 309.823L353.943 324.532L368.652 324.532L368.652 309.823L353.943 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 295.114L353.943 309.823L368.652 309.823L368.652 295.114L353.943 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 280.411L353.943 295.121L368.652 295.121L368.652 280.411L353.943 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 265.702L353.943 280.411L368.653 280.411L368.653 265.702L353.943 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 251L353.943 265.709L368.653 265.709L368.653 251L353.943 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 236.291L353.943 251L368.653 251L368.653 236.291L353.943 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 221.589L353.943 236.298L368.653 236.298L368.653 221.589L353.943 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 206.88L353.943 221.589L368.653 221.589L368.653 206.88L353.943 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 192.178L353.943 206.887L368.653 206.887L368.653 192.178L353.943 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 177.468L353.943 192.177L368.653 192.177L368.653 177.468L353.943 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 162.766L353.943 177.475L368.653 177.475L368.653 162.766L353.943 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 148.057L353.943 162.766L368.653 162.766L368.653 148.057L353.943 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 133.355L353.943 148.064L368.653 148.064L368.653 133.355L353.943 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 118.645L353.943 133.354L368.653 133.354L368.653 118.645L353.943 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 103.936L353.943 118.646L368.653 118.646L368.653 103.936L353.943 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 89.2341L353.943 103.943L368.653 103.943L368.653 89.2341L353.943 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 74.5251L353.943 89.2344L368.653 89.2344L368.653 74.5251L353.943 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 59.823L353.943 74.5322L368.653 74.5322L368.653 59.823L353.943 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 45.1135L353.943 59.8228L368.653 59.8228L368.653 45.1135L353.943 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 30.4114L353.943 45.1206L368.653 45.1206L368.653 30.4114L353.943 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 15.7024L353.943 30.4116L368.653 30.4116L368.653 15.7024L353.943 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.943 1.00026L353.943 15.7095L368.653 15.7095L368.653 1.00026L353.943 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 368.646L368.645 383.355L383.354 383.355L383.354 368.646L368.645 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 353.936L368.645 368.646L383.354 368.646L383.354 353.936L368.645 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 339.234L368.645 353.943L383.354 353.943L383.354 339.234L368.645 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 324.525L368.645 339.234L383.354 339.234L383.354 324.525L368.645 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 309.823L368.645 324.532L383.354 324.532L383.354 309.823L368.645 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 295.114L368.645 309.823L383.354 309.823L383.354 295.114L368.645 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 280.411L368.645 295.121L383.354 295.121L383.354 280.411L368.645 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 265.702L368.645 280.411L383.354 280.411L383.354 265.702L368.645 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 251L368.645 265.709L383.354 265.709L383.354 251L368.645 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 236.291L368.645 251L383.354 251L383.354 236.291L368.645 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 221.589L368.645 236.298L383.354 236.298L383.354 221.589L368.645 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 206.88L368.645 221.589L383.354 221.589L383.354 206.88L368.645 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 192.178L368.645 206.887L383.354 206.887L383.354 192.178L368.645 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 177.468L368.645 192.177L383.354 192.177L383.354 177.468L368.645 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 162.766L368.645 177.475L383.354 177.475L383.354 162.766L368.645 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 148.057L368.645 162.766L383.354 162.766L383.354 148.057L368.645 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 133.355L368.645 148.064L383.354 148.064L383.354 133.355L368.645 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 118.645L368.645 133.354L383.354 133.354L383.354 118.645L368.645 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 103.936L368.645 118.646L383.354 118.646L383.354 103.936L368.645 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 89.2341L368.645 103.943L383.354 103.943L383.354 89.2341L368.645 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 74.5251L368.645 89.2344L383.354 89.2344L383.354 74.5251L368.645 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 59.823L368.645 74.5322L383.354 74.5322L383.354 59.823L368.645 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 45.1135L368.645 59.8228L383.354 59.8228L383.354 45.1135L368.645 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 30.4114L368.645 45.1206L383.354 45.1206L383.354 30.4114L368.645 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 15.7024L368.645 30.4116L383.354 30.4116L383.354 15.7024L368.645 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.645 1.00026L368.645 15.7095L383.354 15.7095L383.354 1.00026L368.645 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 368.646L383.355 383.355L398.065 383.355L398.065 368.646L383.355 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 353.936L383.355 368.646L398.065 368.646L398.065 353.936L383.355 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 339.234L383.355 353.943L398.065 353.943L398.065 339.234L383.355 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 324.525L383.355 339.234L398.065 339.234L398.065 324.525L383.355 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 309.823L383.355 324.532L398.065 324.532L398.065 309.823L383.355 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 295.114L383.355 309.823L398.065 309.823L398.065 295.114L383.355 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 280.411L383.355 295.121L398.065 295.121L398.065 280.411L383.355 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 265.702L383.355 280.411L398.065 280.411L398.065 265.702L383.355 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 251L383.355 265.709L398.065 265.709L398.065 251L383.355 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 236.291L383.355 251L398.065 251L398.065 236.291L383.355 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 221.589L383.355 236.298L398.065 236.298L398.065 221.589L383.355 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 206.88L383.355 221.589L398.065 221.589L398.065 206.88L383.355 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 192.178L383.355 206.887L398.065 206.887L398.065 192.178L383.355 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 177.468L383.355 192.177L398.065 192.177L398.065 177.468L383.355 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 162.766L383.355 177.475L398.065 177.475L398.065 162.766L383.355 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 148.057L383.355 162.766L398.065 162.766L398.065 148.057L383.355 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 133.355L383.355 148.064L398.065 148.064L398.065 133.355L383.355 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 118.645L383.355 133.354L398.065 133.354L398.065 118.645L383.355 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 103.936L383.355 118.646L398.065 118.646L398.065 103.936L383.355 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 89.2341L383.355 103.943L398.065 103.943L398.065 89.2341L383.355 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 74.5251L383.355 89.2344L398.065 89.2344L398.065 74.5251L383.355 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 59.823L383.355 74.5322L398.065 74.5322L398.065 59.823L383.355 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 45.1135L383.355 59.8228L398.065 59.8228L398.065 45.1135L383.355 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 30.4114L383.355 45.1206L398.065 45.1206L398.065 30.4114L383.355 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 15.7024L383.355 30.4116L398.065 30.4116L398.065 15.7024L383.355 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.355 1.00026L383.355 15.7095L398.065 15.7095L398.065 1.00026L383.355 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 368.646L398.057 383.355L412.766 383.355L412.766 368.646L398.057 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 353.936L398.057 368.646L412.766 368.646L412.766 353.936L398.057 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 339.234L398.057 353.943L412.766 353.943L412.766 339.234L398.057 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 324.525L398.057 339.234L412.766 339.234L412.766 324.525L398.057 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 309.823L398.057 324.532L412.766 324.532L412.766 309.823L398.057 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 295.114L398.057 309.823L412.766 309.823L412.766 295.114L398.057 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 280.411L398.057 295.121L412.766 295.121L412.766 280.411L398.057 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 265.702L398.057 280.411L412.766 280.411L412.766 265.702L398.057 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 251L398.057 265.709L412.766 265.709L412.766 251L398.057 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 236.291L398.057 251L412.766 251L412.766 236.291L398.057 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 221.589L398.057 236.298L412.766 236.298L412.766 221.589L398.057 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 206.88L398.057 221.589L412.766 221.589L412.766 206.88L398.057 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 192.178L398.057 206.887L412.766 206.887L412.766 192.178L398.057 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 177.468L398.057 192.177L412.766 192.177L412.766 177.468L398.057 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 162.766L398.057 177.475L412.766 177.475L412.766 162.766L398.057 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 148.057L398.057 162.766L412.766 162.766L412.766 148.057L398.057 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 133.355L398.057 148.064L412.766 148.064L412.766 133.355L398.057 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 118.645L398.057 133.354L412.766 133.354L412.766 118.645L398.057 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 103.936L398.057 118.646L412.766 118.646L412.766 103.936L398.057 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 89.2341L398.057 103.943L412.766 103.943L412.766 89.2341L398.057 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 74.5251L398.057 89.2344L412.766 89.2344L412.766 74.5251L398.057 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 59.823L398.057 74.5322L412.766 74.5322L412.766 59.823L398.057 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 45.1135L398.057 59.8228L412.766 59.8228L412.766 45.1135L398.057 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 30.4114L398.057 45.1206L412.766 45.1206L412.766 30.4114L398.057 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 15.7024L398.057 30.4116L412.766 30.4116L412.766 15.7024L398.057 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.057 1.00026L398.057 15.7095L412.766 15.7095L412.766 1.00026L398.057 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 368.646L412.766 383.355L427.475 383.355L427.475 368.646L412.766 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 353.936L412.766 368.646L427.475 368.646L427.475 353.936L412.766 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 339.234L412.766 353.943L427.475 353.943L427.475 339.234L412.766 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 324.525L412.766 339.234L427.475 339.234L427.475 324.525L412.766 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 309.823L412.766 324.532L427.475 324.532L427.475 309.823L412.766 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 295.114L412.766 309.823L427.475 309.823L427.475 295.114L412.766 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 280.411L412.766 295.121L427.475 295.121L427.475 280.411L412.766 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 265.702L412.766 280.411L427.475 280.411L427.475 265.702L412.766 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 251L412.766 265.709L427.475 265.709L427.475 251L412.766 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 236.291L412.766 251L427.475 251L427.475 236.291L412.766 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 221.589L412.766 236.298L427.475 236.298L427.475 221.589L412.766 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 206.88L412.766 221.589L427.475 221.589L427.475 206.88L412.766 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 192.178L412.766 206.887L427.475 206.887L427.475 192.178L412.766 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 177.468L412.766 192.177L427.475 192.177L427.475 177.468L412.766 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 162.766L412.766 177.475L427.475 177.475L427.475 162.766L412.766 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 148.057L412.766 162.766L427.475 162.766L427.475 148.057L412.766 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 133.355L412.766 148.064L427.475 148.064L427.475 133.355L412.766 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 118.645L412.766 133.354L427.475 133.354L427.475 118.645L412.766 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 103.936L412.766 118.646L427.475 118.646L427.475 103.936L412.766 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 89.2341L412.766 103.943L427.475 103.943L427.475 89.2341L412.766 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 74.5251L412.766 89.2344L427.475 89.2344L427.475 74.5251L412.766 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 59.823L412.766 74.5322L427.475 74.5322L427.475 59.823L412.766 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 45.1135L412.766 59.8228L427.475 59.8228L427.475 45.1135L412.766 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 30.4114L412.766 45.1206L427.475 45.1206L427.475 30.4114L412.766 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 15.7024L412.766 30.4116L427.475 30.4116L427.475 15.7024L412.766 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.766 1.00026L412.766 15.7095L427.475 15.7095L427.475 1.00026L412.766 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 368.646L427.469 383.355L442.178 383.355L442.178 368.646L427.469 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 353.936L427.469 368.646L442.178 368.646L442.178 353.936L427.469 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 339.234L427.469 353.943L442.178 353.943L442.178 339.234L427.469 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 324.525L427.469 339.234L442.178 339.234L442.178 324.525L427.469 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 309.823L427.469 324.532L442.178 324.532L442.178 309.823L427.469 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 295.114L427.469 309.823L442.178 309.823L442.178 295.114L427.469 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 280.411L427.469 295.121L442.178 295.121L442.178 280.411L427.469 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 265.702L427.469 280.411L442.178 280.411L442.178 265.702L427.469 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 251L427.469 265.709L442.178 265.709L442.178 251L427.469 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 236.291L427.469 251L442.178 251L442.178 236.291L427.469 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 221.589L427.469 236.298L442.178 236.298L442.178 221.589L427.469 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 206.88L427.469 221.589L442.178 221.589L442.178 206.88L427.469 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 192.178L427.469 206.887L442.178 206.887L442.178 192.178L427.469 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 177.468L427.469 192.177L442.178 192.177L442.178 177.468L427.469 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 162.766L427.469 177.475L442.178 177.475L442.178 162.766L427.469 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 148.057L427.469 162.766L442.178 162.766L442.178 148.057L427.469 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 133.355L427.469 148.064L442.178 148.064L442.178 133.355L427.469 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 118.645L427.469 133.354L442.178 133.354L442.178 118.645L427.469 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 103.936L427.469 118.646L442.178 118.646L442.178 103.936L427.469 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 89.2341L427.469 103.943L442.178 103.943L442.178 89.2341L427.469 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 74.5251L427.469 89.2344L442.178 89.2344L442.178 74.5251L427.469 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 59.823L427.469 74.5322L442.178 74.5322L442.178 59.823L427.469 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 45.1135L427.469 59.8228L442.178 59.8228L442.178 45.1135L427.469 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 30.4114L427.469 45.1206L442.178 45.1206L442.178 30.4114L427.469 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 15.7024L427.469 30.4116L442.178 30.4116L442.178 15.7024L427.469 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.469 1.00026L427.469 15.7095L442.178 15.7095L442.178 1.00026L427.469 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 368.646L442.178 383.355L456.887 383.355L456.887 368.646L442.178 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 353.936L442.178 368.646L456.887 368.646L456.887 353.936L442.178 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 339.234L442.178 353.943L456.887 353.943L456.887 339.234L442.178 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 324.525L442.178 339.234L456.887 339.234L456.887 324.525L442.178 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 309.823L442.178 324.532L456.887 324.532L456.887 309.823L442.178 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 295.114L442.178 309.823L456.887 309.823L456.887 295.114L442.178 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 280.411L442.178 295.121L456.887 295.121L456.887 280.411L442.178 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 265.702L442.178 280.411L456.887 280.411L456.887 265.702L442.178 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 251L442.178 265.709L456.887 265.709L456.887 251L442.178 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 236.291L442.178 251L456.887 251L456.887 236.291L442.178 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 221.589L442.178 236.298L456.887 236.298L456.887 221.589L442.178 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 206.88L442.178 221.589L456.887 221.589L456.887 206.88L442.178 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 192.178L442.178 206.887L456.887 206.887L456.887 192.178L442.178 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 177.468L442.178 192.177L456.887 192.177L456.887 177.468L442.178 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 162.766L442.178 177.475L456.887 177.475L456.887 162.766L442.178 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 148.057L442.178 162.766L456.887 162.766L456.887 148.057L442.178 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 133.355L442.178 148.064L456.887 148.064L456.887 133.355L442.178 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 118.645L442.178 133.354L456.887 133.354L456.887 118.645L442.178 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 103.936L442.178 118.646L456.887 118.646L456.887 103.936L442.178 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 89.2341L442.178 103.943L456.887 103.943L456.887 89.2341L442.178 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 74.5251L442.178 89.2344L456.887 89.2344L456.887 74.5251L442.178 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 59.823L442.178 74.5322L456.887 74.5322L456.887 59.823L442.178 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 45.1135L442.178 59.8228L456.887 59.8228L456.887 45.1135L442.178 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 30.4114L442.178 45.1206L456.887 45.1206L456.887 30.4114L442.178 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 15.7024L442.178 30.4116L456.887 30.4116L456.887 15.7024L442.178 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.178 1.00026L442.178 15.7095L456.887 15.7095L456.887 1.00026L442.178 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 368.646L456.879 383.355L471.588 383.355L471.588 368.646L456.879 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 353.936L456.879 368.646L471.588 368.646L471.588 353.936L456.879 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 339.234L456.879 353.943L471.588 353.943L471.588 339.234L456.879 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 324.525L456.879 339.234L471.588 339.234L471.588 324.525L456.879 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 309.823L456.879 324.532L471.588 324.532L471.588 309.823L456.879 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 295.114L456.879 309.823L471.588 309.823L471.588 295.114L456.879 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 280.411L456.879 295.121L471.588 295.121L471.588 280.411L456.879 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 265.702L456.879 280.411L471.588 280.411L471.588 265.702L456.879 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 251L456.879 265.709L471.588 265.709L471.588 251L456.879 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 236.291L456.879 251L471.588 251L471.588 236.291L456.879 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 221.589L456.879 236.298L471.588 236.298L471.588 221.589L456.879 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 206.88L456.879 221.589L471.588 221.589L471.588 206.88L456.879 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 192.178L456.879 206.887L471.588 206.887L471.588 192.178L456.879 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 177.468L456.879 192.177L471.588 192.177L471.588 177.468L456.879 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 162.766L456.879 177.475L471.588 177.475L471.588 162.766L456.879 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 148.057L456.879 162.766L471.588 162.766L471.588 148.057L456.879 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 133.355L456.879 148.064L471.588 148.064L471.588 133.355L456.879 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 118.645L456.879 133.354L471.588 133.354L471.588 118.645L456.879 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 103.936L456.879 118.646L471.588 118.646L471.588 103.936L456.879 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 89.2341L456.879 103.943L471.588 103.943L471.588 89.2341L456.879 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 74.5251L456.879 89.2344L471.588 89.2344L471.588 74.5251L456.879 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 59.823L456.879 74.5322L471.588 74.5322L471.588 59.823L456.879 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 45.1135L456.879 59.8228L471.588 59.8228L471.588 45.1135L456.879 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 30.4114L456.879 45.1206L471.588 45.1206L471.588 30.4114L456.879 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 15.7024L456.879 30.4116L471.588 30.4116L471.588 15.7024L456.879 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.879 1.00026L456.879 15.7095L471.588 15.7095L471.588 1.00026L456.879 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 368.646L471.588 383.355L486.297 383.355L486.297 368.646L471.588 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 353.936L471.588 368.646L486.297 368.646L486.297 353.936L471.588 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 339.234L471.588 353.943L486.297 353.943L486.297 339.234L471.588 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 324.525L471.588 339.234L486.297 339.234L486.297 324.525L471.588 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 309.823L471.588 324.532L486.297 324.532L486.297 309.823L471.588 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 295.114L471.588 309.823L486.297 309.823L486.297 295.114L471.588 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 280.411L471.588 295.121L486.297 295.121L486.297 280.411L471.588 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 265.702L471.588 280.411L486.297 280.411L486.297 265.702L471.588 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 251L471.588 265.709L486.297 265.709L486.297 251L471.588 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 236.291L471.588 251L486.297 251L486.297 236.291L471.588 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 221.589L471.588 236.298L486.297 236.298L486.297 221.589L471.588 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 206.88L471.588 221.589L486.297 221.589L486.297 206.88L471.588 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 192.178L471.588 206.887L486.297 206.887L486.297 192.178L471.588 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 177.468L471.588 192.177L486.297 192.177L486.297 177.468L471.588 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 162.766L471.588 177.475L486.297 177.475L486.297 162.766L471.588 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 148.057L471.588 162.766L486.297 162.766L486.297 148.057L471.588 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 133.355L471.588 148.064L486.297 148.064L486.297 133.355L471.588 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 118.645L471.588 133.354L486.297 133.354L486.297 118.645L471.588 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 103.936L471.588 118.646L486.297 118.646L486.297 103.936L471.588 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 89.2341L471.588 103.943L486.297 103.943L486.297 89.2341L471.588 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 74.5251L471.588 89.2344L486.297 89.2344L486.297 74.5251L471.588 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 59.823L471.588 74.5322L486.297 74.5322L486.297 59.823L471.588 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 45.1135L471.588 59.8228L486.297 59.8228L486.297 45.1135L471.588 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 30.4114L471.588 45.1206L486.297 45.1206L486.297 30.4114L471.588 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 15.7024L471.588 30.4116L486.297 30.4116L486.297 15.7024L471.588 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.588 1.00026L471.588 15.7095L486.297 15.7095L486.297 1.00026L471.588 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 368.646L486.291 383.355L501 383.355L501 368.646L486.291 368.646Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 353.936L486.291 368.646L501 368.646L501 353.936L486.291 353.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 339.234L486.291 353.943L501 353.943L501 339.234L486.291 339.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 324.525L486.291 339.234L501 339.234L501 324.525L486.291 324.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 309.823L486.291 324.532L501 324.532L501 309.823L486.291 309.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 295.114L486.291 309.823L501 309.823L501 295.114L486.291 295.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 280.411L486.291 295.121L501 295.121L501 280.411L486.291 280.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 265.702L486.291 280.411L501 280.411L501 265.702L486.291 265.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 251L486.291 265.709L501 265.709L501 251L486.291 251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 236.291L486.291 251L501 251L501 236.291L486.291 236.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 221.589L486.291 236.298L501 236.298L501 221.589L486.291 221.589Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 206.88L486.291 221.589L501 221.589L501 206.88L486.291 206.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 192.178L486.291 206.887L501 206.887L501 192.178L486.291 192.178Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 177.468L486.291 192.177L501 192.177L501 177.468L486.291 177.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 162.766L486.291 177.475L501 177.475L501 162.766L486.291 162.766Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 148.057L486.291 162.766L501 162.766L501 148.057L486.291 148.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 133.355L486.291 148.064L501 148.064L501 133.355L486.291 133.355Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 118.645L486.291 133.354L501 133.354L501 118.645L486.291 118.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 103.936L486.291 118.646L501 118.646L501 103.936L486.291 103.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 89.2341L486.291 103.943L501 103.943L501 89.2341L486.291 89.2341Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 74.5251L486.291 89.2344L501 89.2344L501 74.5251L486.291 74.5251Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 59.823L486.291 74.5322L501 74.5322L501 59.823L486.291 59.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 45.1135L486.291 59.8228L501 59.8228L501 45.1135L486.291 45.1135Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 30.4114L486.291 45.1206L501 45.1206L501 30.4114L486.291 30.4114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 15.7024L486.291 30.4116L501 30.4116L501 15.7024L486.291 15.7024Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.291 1.00026L486.291 15.7095L501 15.7095L501 1.00026L486.291 1.00026Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.5d826b3f7f234959657272ef9064ef12.svg";
export { ForwardRef as ReactComponent };